(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('KeywordDialogController', KeywordDialogController);

    KeywordDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Keyword', 'Contract'];

    function KeywordDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Keyword, Contract) {
        var vm = this;

        vm.keyword = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.contracts = Contract.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.keyword.id !== null) {
                Keyword.update(vm.keyword, onSaveSuccess, onSaveError);
            } else {
                Keyword.save(vm.keyword, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:keywordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
